import { Button } from 'primereact/button';
import React,{useState} from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import AddEditNew from '../components/AddEditNew';

import { Dialog } from 'primereact/dialog';

const Dashboard = () => {
    const [dialog, setDialog] = useState();
    const [editable, setEditable] = useState();
    // Array of objects containing content for each card
    const cards = [
        { id: 1, content: "Z-Product", path: "/adminzproduct" },
        { id: 2, content: "Z-App Journey", path: "/adminzapplourney" },
        { id: 3, content: "Z-Training Material", path: "/adminztrainingmaterial" },
        { id: 4, content: "Tip of the day", path: "/admintipofday" },
        { id: 5, content: "Outages / Degradations", path: "/adminoutage" },
        { id: 6, content: "Disclaimer", path: "/admindisclaimer" },
        { id: 7, content: "Dashboard Slider", path: "/admindashboardslider" },
    ];

    const onHide = () => {
        setDialog(false)
    }

    return (
        <>
            <Dialog visible={dialog} onHide={onHide} header={editable ? "Edit Faqs" : "Add Faqs"} style={{ width: "70vw" }}>
                <AddEditNew />
            </Dialog>
      
        <div className='card'>
            <div className='grid'>
                {/* <div className="md:col-10"></div>
                <div className="md:col-2">
                    <div>
                        <Button className="p-button custom-bg w100" label="Add New"  onClick={() => { setEditable(false); setDialog(true) }}  />
                    </div>
                </div> */}
            </div>
            <div className='md:col-12'>
                <div className='grid'>
                    {/* Mapping through the array of cards and rendering card elements */}
                    {cards.map(card => (
                        <div key={card.id} className='md:col-2'>
                            <div className='card bg_custom mid' style={{height:"100px" }}>
                            <Link className="clr_custom" to={card.path}>
                                        <h4>{card.content}</h4>
                                    </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        </>
    );
}

export default Dashboard;
